import React, { useLayoutEffect } from 'react';
import { StyleSheet } from 'react-native';
import { Button, ButtonGroup, rem } from 'design-system';
import { AppView } from 'design-system/AppView';
import Text from 'design-system/Text';
import { joinGroup } from 'actions';
import NavigationCloseButton from 'design-system/NavigationCloseButton';
import StatusBar from 'design-system/StatusBar';
import { muteErrorAndResult, useFetchOld } from 'hooks';
import IconThreeUser from 'design-system/icons/IconThreeUser';
import Squircle from 'design-system/Squircle';
import useColors from 'hooks/useColors';
const GroupJoinScreen = ({ navigation, route, }) => {
    const [, , isFetching, fetch] = useFetchOld(muteErrorAndResult);
    useLayoutEffect(() => {
        const onDismiss = () => {
            navigation.goBack();
        };
        navigation.setOptions({
            headerLeft: () => (<NavigationCloseButton onPress={onDismiss} colorKey="primary"/>),
        });
    }, []);
    const onJoined = async () => {
        const code = route.params.accessCode;
        const result = await fetch(joinGroup(code.replace('}', '')));
        if (result) {
            navigation.popToTop();
            navigation.push('Group', { id: result.group.id });
        }
    };
    const colors = useColors();
    return (<AppView style={styles.content}>
      <StatusBar barStyle="dark-content" animated/>
      <Squircle width={rem(80)} height={rem(80)} color={colors.cards.onDark}>
        <IconThreeUser gradientKey="orange" width={rem(40)} height={rem(40)}/>
      </Squircle>
      <Text Text-24 centered style={styles.title}>
        Join Group
      </Text>
      <Text TextThin-16 Secondary centered>
        You are invited to join a group!
      </Text>
      <ButtonGroup type="floating">
        <Button brand title="Join a group" onPress={onJoined} isFetching={isFetching}/>
      </ButtonGroup>
    </AppView>);
};
const styles = StyleSheet.create({
    content: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    title: {
        marginTop: rem(24),
        marginBottom: rem(8),
    },
});
export default GroupJoinScreen;
